import request from '../request';

export function getPermissions(params) {
  return request({
    url: "management/permissions",
    method: "get",
    params
  })
}

export function getPagePermissions(id) {
  return request({
    url: `management/permissions?page=${id}`,
    method: "get"
  })
}

export function getID(id) {
  return request({
    url: `management/permissions/${id}`,
    method: "get",
  })
}

export function postPermissions(data) {
  return request({
    url: "management/permissions",
    method: "post",
    data
  })
}

export function deletePermissions(id) {
  return request({
    url: `management/permissions/${id}`,
    method: "delete",
    id
  })
}

export function putPermissions(data) {
  return request({
    url: `management/permissions/${data.id}`,
    method: "put",
    data
  })
}

